import React from 'react';
import LandingFooter from './Landing/LandingFooter';

const AppFooter = () => {
  return <LandingFooter />;
};

export default AppFooter;


